import { useDailyMetrics } from 'new/stores/metrics/metrics.api';
import type { DailyMetrics, DailyMetricsParams } from 'new/stores/metrics/metrics.endpoints';

interface DailyMetricsRepositoryHookReturn {
  data: DailyMetrics | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
}

export default function useDailyMetricsRepository(
  params: DailyMetricsParams,
  options?: { skip?: boolean },
): DailyMetricsRepositoryHookReturn {
  const hasScope =
    params.origin_node_id != null || params.org_id != null || params.owner_id != null;

  const skip = options?.skip ?? !hasScope;

  const result = useDailyMetrics(params, { skip });

  return {
    data: result.data as DailyMetrics | undefined,
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    error: result.error,
  };
}

export { useDailyMetricsRepository };
